import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { AccessContext } from '@invenco/common-interface/auth';

import { SidebarInset, SidebarProvider } from '@/components/core/sidebar';
import { NavigationSidebar } from '@/components/navigation-sidebar';
import { useGateways } from '@/gateways/GatewayProvider';
import { useAuthToken } from '@/shared/hooks/useAuthToken';
import { useNewUiFeatureFlag } from '@/shared/hooks/useNewUiFeatureFlag';
import { listViewsQueryOptions } from '@/shared/queries/listViewsQueryOptions';
import { PageContainer, RouteContainer } from '@/styles/layout';

import { NoContextRoutes } from '../no-context/routes';
import { PlatformRoutes } from '../platform/routes';
import { SellerRoutes } from '../seller/routes';
import { WarehouseRoutes } from '../warehouse/routes';
import { Navigation } from './navigation/Navigation';

function HomeImpl() {
  const { accessContext } = useAuthToken();
  const { accountsGateway } = useGateways();
  const queryClient = useQueryClient();
  const isNewUi = useNewUiFeatureFlag();
  // preload data depending on access context
  useEffect(() => {
    if (accessContext === AccessContext.SELLER) {
      void queryClient.prefetchQuery(listViewsQueryOptions(accountsGateway));
    }
  }, [accessContext, queryClient, accountsGateway]);

  const getRoutes = () => {
    switch (accessContext) {
      case AccessContext.SELLER:
        return <SellerRoutes />;
      case AccessContext.PLATFORM:
        return <PlatformRoutes />;
      case AccessContext.WAREHOUSE:
        return <WarehouseRoutes />;
      default:
        return <NoContextRoutes />;
    }
  };

  // TODO ENG-3377 - replace the final return layout with the one in this if statement
  if (isNewUi) {
    return (
      <SidebarProvider>
        <NavigationSidebar accessContext={accessContext} />
        <SidebarInset>{getRoutes()}</SidebarInset>
      </SidebarProvider>
    );
  }

  return (
    <PageContainer>
      <Navigation />
      <RouteContainer>{getRoutes()}</RouteContainer>
    </PageContainer>
  );
}

export const Home = withAuthenticationRequired(HomeImpl);
